import React, { useEffect, useState } from 'react';

const CarnetDirectorModal = ({
  isOpen,
  onClose,
  onConfirm,
  defaultNombre = '',
  defaultCedula = '',
  submitting = false,
}) => {
  const [nombreDirectora, setNombreDirectora] = useState(defaultNombre);
  const [cedulaDirectora, setCedulaDirectora] = useState(defaultCedula);
  const [logoFile, setLogoFile] = useState(null);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (isOpen) {
      setNombreDirectora(defaultNombre || '');
      setCedulaDirectora(defaultCedula || '');
      setErrors({});
    }
  }, [isOpen, defaultNombre, defaultCedula]);

  const validate = () => {
    const e = {};
    if (!nombreDirectora.trim()) e.nombreDirectora = 'Ingrese el nombre de la directora';
    if (!cedulaDirectora.trim()) {
      e.cedulaDirectora = 'Ingrese la cédula de la directora';
    } else if (!/^\d{10}$/.test(cedulaDirectora.trim())) {
      e.cedulaDirectora = 'La cédula debe tener exactamente 10 dígitos';
    }
    if (!logoFile) {
      e.logoFile = 'Seleccione un logo (PNG/JPG, máx. 2MB)';
    } else if (!(logoFile.type === 'image/png' || logoFile.type === 'image/jpeg') || logoFile.size > 2 * 1024 * 1024) {
      e.logoFile = 'Logo inválido: debe ser PNG/JPG y no superar 2MB';
    }
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  if (!validate()) return;
  onConfirm?.({ nombreDirectora: nombreDirectora.trim(), cedulaDirectora: cedulaDirectora.trim(), logoFile });
  };

  if (!isOpen) return null;
  return (
    <div className="modal" style={{ zIndex: 2150 }}>
      <div className="modal-content" style={{ width: 520 }}>
        <div className="modal-header" style={{ background:'#821C53', color:'#fff' }}>
          <h3>Datos para Carnet</h3>
          <button className="close-btn" onClick={onClose} style={{ color:'#fff' }}>
            <i className="fas fa-times"></i>
          </button>
        </div>
        <div className="modal-body">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Nombre de la Directora</label>
              <input
                type="text"
                value={nombreDirectora}
                onChange={(e)=>setNombreDirectora(e.target.value)}
                placeholder="Ingresa el nombre completo"
                className={errors.nombreDirectora ? 'error' : ''}
              />
              {errors.nombreDirectora && <span className="error-message">{errors.nombreDirectora}</span>}
            </div>
            <div className="form-group">
              <label>Cédula de la Directora</label>
              <input
                type="text"
                value={cedulaDirectora}
                onChange={(e)=>setCedulaDirectora(e.target.value)}
                placeholder="Ingresa la cédula"
                className={errors.cedulaDirectora ? 'error' : ''}
              />
              {errors.cedulaDirectora && <span className="error-message">{errors.cedulaDirectora}</span>}
            </div>
            <div className="form-group">
              <label>Logo (PNG/JPG, máx 2MB)</label>
              <input type="file" accept="image/png, image/jpeg" onChange={(e)=>setLogoFile(e.target.files?.[0]||null)} />
              {errors.logoFile && <span className="error-message">{errors.logoFile}</span>}
            </div>
            <div className="modal-actions">
              <button type="submit" className="btn-primary" disabled={submitting}>
                {submitting ? 'Generando…' : 'Continuar'}
              </button>
              <button type="button" className="btn-secondary" onClick={onClose} disabled={submitting}>Cancelar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CarnetDirectorModal;
